import { ReactNode, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      window.scrollTo(0, 0);
      prevPathname.current = pathname;
    }
  }, [pathname]);

  return <>{children}</>;
}
